import { render, staticRenderFns } from "./review-section-info.vue?vue&type=template&id=4fec188a&"
import script from "./review-section-info.vue?vue&type=script&lang=js&"
export * from "./review-section-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports